<template>
    <div class="login" :class="{ weflix: isWeflix }">
        <div class="content">
            <div class="info" style="cursor: default">
                <div class="logo">
                    <img
                        alt="Weeduc"
                        src="@/assets/Weflix/Weflix-Logo-Total-Branco.png"
                        style="width: 200px"
                        v-show="isWeflix"
                    />
                    <img
                        alt="Weeduc"
                        src="@/assets/logo_white.png"
                        style="width: 200px"
                        v-show="isWeeduc"
                    />
                </div>
                
                <div class="form">
                    <form @submit.prevent="changePassword" class="form">
                        <h4 class="form-title">Redefinir Senha</h4>
                        <p class="form-subtitle">Digite sua nova senha</p>
  
                        <div class="mb-3 password">
                            <label for="password" class="form-label">Nova Senha</label>
                            <input
                                v-model="password"
                                :type="showPassword"
                                class="form-control"
                                :class="{ 'is-invalid': passwordError }"
                                id="password"
                                required
                                :disabled="isLoading"
                                minlength="8"
                                placeholder="Digite sua nova senha (mínimo 8 caracteres)"
                                @input="validatePassword"
                            />
                            <div class="invalid-feedback" v-if="passwordError">
                                {{ passwordError }}
                            </div>
                            <fa
                                icon="eye"
                                style="cursor: pointer"
                                v-show="showPassword == 'text'"
                                @click="changeViewPassword()"
                            />
                            <fa
                                icon="eye-slash"
                                style="cursor: pointer"
                                v-show="showPassword == 'password'"
                                @click="changeViewPassword()"
                            />
                        </div>
  
                        <div class="mb-3 password">
                            <label for="confirmPassword" class="form-label">Confirmar Nova Senha</label>
                            <input
                                v-model="confirmPassword"
                                :type="showConfirmPassword"
                                class="form-control"
                                :class="{ 'is-invalid': confirmPasswordError }"
                                id="confirmPassword"
                                required
                                :disabled="isLoading"
                                minlength="8"
                                placeholder="Confirme sua nova senha (mínimo 8 caracteres)"
                                @input="validateConfirmPassword"
                            />
                            <div class="invalid-feedback" v-if="confirmPasswordError">
                                {{ confirmPasswordError }}
                            </div>
                            <fa
                                icon="eye"
                                style="cursor: pointer"
                                v-show="showConfirmPassword == 'text'"
                                @click="changeViewConfirmPassword()"
                            />
                            <fa
                                icon="eye-slash"
                                style="cursor: pointer"
                                v-show="showConfirmPassword == 'password'"
                                @click="changeViewConfirmPassword()"
                            />
                        </div>
  
                        <div class="erro" v-show="erroReset">
                            <small>{{ mensageErro }}</small>
                        </div>
  
                        <div class="success" v-show="successReset">
                            <small>{{ mensageSuccess }}</small>
                        </div>
  
                        <div class="mb-4 text-center" style="margin-top: 32px;">
                            <button
                                type="submit"
                                class="btn-success"
                                :class="{
                                    weflix: typeSystemLocal == 1 || typeSystemLocal == 2,
                                }"
                                :disabled="isLoading || !isFormValid"
                            >
                                <span v-if="isLoading">Redefinindo...</span>
                                <span v-else>Redefinir Senha</span>
                            </button>
                        </div>
  
                        <div class="text-center">
                            <a
                                href="/login"
                                :class="{ weflix: typeSystemLocal == 2 }"
                                class="back-to-login"
                            >
                                Voltar ao Login
                            </a>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </div>
  </template>

<script>
import ApiPassword from '@/utils/password.js';
  export default {
      name: 'ResetPassword',
      data() {
            return {
                password: '',
                confirmPassword: '',
                passwordError: '',
                confirmPasswordError: '',
                token: null,
                showPassword: 'password',
                showConfirmPassword: 'password',
                mensageErro: 'Erro ao redefinir senha. Verifique os dados e tente novamente.',
                mensageSuccess: 'Senha redefinida com sucesso!',
                erroReset: false,
                successReset: false,
                isLoading: false,
                typeSystemLocal: 1,
            };
      },
      computed: {
            isFormValid() {
                return this.password && 
                       this.confirmPassword && 
                       this.password === this.confirmPassword && 
                       this.password.length >= 8 &&
                       !this.passwordError &&
                       !this.confirmPasswordError &&
                       this.token;
            },
            isWeflix() {
                return (
                    window.location.origin === 'https://app.weflix.com.br' ||
                    window.location.origin === 'http://localhost:8080' ||
                    window.location.origin === 'http://localhost:8081' ||
                    window.location.origin === 'https://homolog.weflix.com.br'
                );
            },
            isWeeduc() {
                return (
                    window.location.origin === 'https://app.weeduc.com.br' ||
                    window.location.origin === 'http://localhost:8080' ||
                    window.location.origin === 'http://localhost:8081' ||
                    window.location.origin === 'https://homolog.weeduc.com.br'
                );
            },
      },
      methods: {
          changeViewPassword() {
              if (this.showPassword == 'password') {
                  this.showPassword = 'text';
              } else {
                  this.showPassword = 'password';
              }
          },
            changeViewConfirmPassword() {
                if (this.showConfirmPassword == 'password') {
                    this.showConfirmPassword = 'text';
                } else {
                    this.showConfirmPassword = 'password';
                }
            },
         
            validatePassword() {
                this.passwordError = '';
                
                if (this.password.length > 0 && this.password.length < 8) {
                    this.passwordError = 'A senha deve ter pelo menos 8 caracteres';
                }
                
                // Revalidar confirmação de senha se já foi digitada
                if (this.confirmPassword) {
                    this.validateConfirmPassword();
                }
            },
            validateConfirmPassword() {
                this.confirmPasswordError = '';
                
                if (this.confirmPassword.length > 0 && this.confirmPassword.length < 8) {
                    this.confirmPasswordError = 'A confirmação de senha deve ter pelo menos 8 caracteres';
                } else if (this.confirmPassword && this.password !== this.confirmPassword) {
                    this.confirmPasswordError = 'As senhas não coincidem';
                }
            },
          async changePassword() {
              if (!this.isFormValid) {
                  return;
              }

              this.isLoading = true;
              this.erroReset = false;
              this.successReset = false;

              try {
                const payload = {
                    "password": this.password,
                    "token": this.token
                }

                await ApiPassword.resetPassowrd(payload);
                  
                  this.successReset = true;
                  this.erroReset = false;
                  
                  // Redirecionar para login após 3 segundos
                  setTimeout(() => {
                      this.$router.push('/login');
                  }, 3000);
                  
              } catch (error) {
                  console.error('Erro ao redefinir senha:', error);
                  this.erroReset = true;
                  this.successReset = false;
                  this.mensageErro = error.response?.data?.message || 'Erro ao redefinir senha. Tente novamente.';
              } finally {
                  this.isLoading = false;
              }
          },
          getTokenFromUrl() {
              // Extrai o token do path da URL (ex: /redefinir-senha/123)
              const pathParts = window.location.pathname.split('/');
              const tokenIndex = pathParts.findIndex(part => part === 'redefinir-senha');
              
              if (tokenIndex !== -1 && pathParts[tokenIndex + 1]) {
                  this.token = pathParts[tokenIndex + 1];
              } else {
                  this.erroReset = true;
                  this.mensageErro = 'Token de redefinição não encontrado na URL.';
              }
          },
      },
      mounted() {
          this.getTokenFromUrl();
      },
  };
</script>

<style scoped>
  .item {
      border: none;
  }
  .form {
      max-width: 100%;
      margin: 0;
      text-align: left;
      min-height: auto;
      position: relative;
  }
  .login {
      height: 100vh;
      display: flex;
      background-image: url('@/assets/Weflix/bg-login-weflix.png');
      background-size: cover;
  }
  .login.weflix {
      height: 100vh;
      display: flex;
      background-image: url('@/assets/Weflix/bg-login-weflix.png');
      background-size: cover;
  }
  .mb-5.text-center.btn {
      width: 100%;
      position: absolute;
      bottom: 0;
  }
  .logo {
      display: flex;
      justify-content: center;
      margin: 20px;
      margin-top: -100px;
      margin-bottom: 40px;
      transform: translateY(-10px);
      filter: drop-shadow(0 4px 8px rgba(0, 0, 0, 0.1));
  }
  .content {
      width: 100%;
      align-items: center;
      display: flex;
      justify-content: center;
      gap: 10px;
  }
  .info {
      width: 450px;
      min-height: 500px;
      padding: 40px 30px;
      background-color: white;
      border-radius: 16px;
      display: flex;
      flex-direction: column;
      justify-content: flex-start;
      box-shadow: 0 20px 40px rgba(0, 0, 0, 0.1);
      backdrop-filter: blur(10px);
      border: 1px solid rgba(255, 255, 255, 0.2);
  }
  button.btn.btn-success {
      width: 100%;
      padding: 14px 24px;
      font-size: 16px;
      font-weight: 600;
      border-radius: 12px;
      border: none;
      background: linear-gradient(135deg, #19c7d0 0%, #17a2b8 100%);
      color: white;
      transition: all 0.3s ease;
      text-transform: uppercase;
      letter-spacing: 0.5px;
      box-shadow: 0 4px 15px rgba(25, 199, 208, 0.3);
  }
  button.btn.btn-success:hover {
      transform: translateY(-2px);
      box-shadow: 0 6px 20px rgba(25, 199, 208, 0.4);
      background: linear-gradient(135deg, #17a2b8 0%, #19c7d0 100%);
  }
  button.btn.btn-success:active {
      transform: translateY(0);
  }
  button.btn.btn-success:disabled {
      opacity: 0.6;
      cursor: not-allowed;
      transform: none;
      box-shadow: 0 2px 8px rgba(25, 199, 208, 0.2);
  }
  .mb-3 {
      margin: 20px 0px;
  }
  .mb-3.forgot_password {
      color: red;
      margin: 0 !important;
      font-size: 11px;
      text-decoration: none;
      display: flex;
      justify-content: end;
  }
  .mb-3.forgot_password a {
      color: #19c7d0;
  }
  .mb-3.password {
      position: relative;
  }
  .mb-3.password i {
      position: absolute;
      top: 45px;
      right: 15px;
      color: #b4b4b4;
      cursor: pointer;
      transition: color 0.3s ease;
  }
  .mb-3.password i:hover {
      color: #19c7d0;
  }
  .form-control {
      border: 2px solid #e9ecef;
      border-radius: 12px;
      padding: 12px 16px;
      font-size: 16px;
      transition: all 0.3s ease;
      background-color: #f8f9fa;
  }
  .form-control:focus {
      border-color: #19c7d0;
      box-shadow: 0 0 0 0.2rem rgba(25, 199, 208, 0.25);
      background-color: white;
  }
  .form-control.is-invalid {
      border-color: #dc3545;
      box-shadow: 0 0 0 0.2rem rgba(220, 53, 69, 0.25);
  }
  .invalid-feedback {
      display: block;
      width: 100%;
      margin-top: 0.25rem;
      font-size: 0.875rem;
      color: #dc3545;
      font-weight: 500;
  }
  .form-control::placeholder {
      color: #adb5bd;
      font-size: 14px;
  }
  .erro {
      margin: 16px 0;
      padding: 12px 16px;
      background-color: #f8d7da;
      border: 1px solid #f5c6cb;
      border-radius: 8px;
      animation: slideIn 0.3s ease;
  }
  .erro small {
      color: #721c24;
      font-weight: 500;
      font-size: 14px;
  }
  .success {
      margin: 16px 0;
      padding: 12px 16px;
      background-color: #d4edda;
      border: 1px solid #c3e6cb;
      border-radius: 8px;
      animation: slideIn 0.3s ease;
  }
  .success small {
      color: #155724;
      font-weight: 500;
      font-size: 14px;
  }
  @keyframes slideIn {
      from {
          opacity: 0;
          transform: translateY(-10px);
      }
      to {
          opacity: 1;
          transform: translateY(0);
      }
  }
  .form-title {
      text-align: center;
      margin-bottom: 8px;
      color: #2c3e50;
      font-weight: 700;
      font-size: 28px;
      letter-spacing: -0.5px;
  }
  .form-subtitle {
      text-align: center;
      margin-bottom: 32px;
      color: #6c757d;
      font-size: 16px;
      line-height: 1.5;
  }
  .form-label {
      font-weight: 600;
      color: #495057;
      margin-bottom: 8px;
      font-size: 14px;
      text-transform: uppercase;
      letter-spacing: 0.5px;
  }
  .back-to-login {
      color: #19c7d0;
      text-decoration: none;
      font-size: 14px;
      font-weight: 500;
      transition: all 0.3s ease;
      display: inline-flex;
      align-items: center;
      gap: 8px;
  }
  .back-to-login:hover {
      color: #17a2b8;
      text-decoration: none;
      transform: translateX(-2px);
  }
  .back-to-login.weflix {
      color: #0d1a7e;
  }
  .back-to-login.weflix:hover {
      color: #1a237e;
  }
  button:disabled {
      opacity: 0.6;
      cursor: not-allowed;
  }
  button.btn-success.weflix {
      background: linear-gradient(135deg, #0d1a7e 0%, #1a237e 100%) !important;
      width: 100%;
      color: white;
      padding: 14px 24px;
      border-radius: 12px;
      box-shadow: 0 4px 15px rgba(13, 26, 126, 0.3);
  }
  button.btn-success.weflix:hover {
      background: linear-gradient(135deg, #1a237e 0%, #0d1a7e 100%) !important;
      box-shadow: 0 6px 20px rgba(13, 26, 126, 0.4);
  }
  a.weflix {
      color: #0d1a7e !important;
  }

  @media (max-width: 600px) {
      .info {
          width: 87%;
          min-height: 450px;
          padding: 30px 20px;
      }

      .logo {
          margin-top: -90px;
          margin-bottom: 30px;
      }
      .form {
          margin: 0px 10px;
          padding-bottom: 10px;
      }
      .mb-3 {
          margin: 12px 0px;
      }
  }
  svg.svg-inline--fa.fa-eye,
  svg.svg-inline--fa.fa-eye-slash {
      position: absolute;
      top: 45px;
      right: 5px;
      font-size: 15px !important;
      color: #dee2e6 !important;
  }
</style>
